import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import TabelHeader from './components/TabelHeader.vue';
import EditTable from './components/EditTable.vue';
import TabelToolBar from './components/TabelToolBar';
import { ExportBoxCodeData, LoadData, GetBoxCodeDetailList, GetNextById, GetLastById, SaveData, CreatePartDetailDataOuterBox, CreateBoxCodeData } from '@/api/DeliveryCode';
import { GetDetailList } from '@/api/MaintainDeliveryNote2';
import util from '@/libs/util';
import { GetReportID as _GetReportID } from '@/api/SysReportTpl';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  mixins: [ExportListMixin],
  components: {
    TabelHeader: TabelHeader,
    EditTable: EditTable,
    TabelToolBar: TabelToolBar
  },
  mounted: function mounted() {
    this.GetReportID();
  },
  data: function data() {
    return {
      isShowTabelHeader: false,
      TabelHeaderData: null,
      onSaveID: null,
      pageInfo: {
        TotalCount: null,
        PageSize: 10,
        PageIndex: 1
      },
      DELIVERY_NO: null,
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      ID: null,
      templateID: null,
      loading: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/OuterBoxLabelManagement', ['setOrderStatu'])), {}, {
    // cb选择的送货单ID
    cbSelectedID: function cbSelectedID(ID) {
      this.ID = ID;
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageInfo.PageIndex = value;
      this.GetPartBarcodeDetailList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.pageInfo.PageSize = value;
      this.GetPartBarcodeDetailList();
    },
    // 点击单号打印
    handleRowPrint: function handleRowPrint(row) {
      // this.$refs.TabelHeader.PrintRowOuterBoxLabel(row)
      if (!this.templateID) {
        this.$message({
          showClose: true,
          message: this.$t('找不到条码打印模板！'),
          type: 'warning'
        });
        return;
      }

      var token = util.cookies.get('token');
      var dataurl = process.env.VUE_APP_API + "/DnBarcode/GetPartBarcodeDetailList?mst_id=".concat(row.MST_ID, "||BARCODE=").concat(row.BARCODE);
      var dxurl = this.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
      var url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(this.templateID, "&Token=").concat(token); // console.log('打印url',url);

      util.open(url);
    },
    // 点击返回
    onHandleBlackBtn: function onHandleBlackBtn() {
      var _this = this;

      // console.log('$OuterBoxLabelManagementOrderState',this.$OuterBoxLabelManagementOrderState);
      if (this.$OuterBoxLabelManagementOrderState === 'addOrder' || this.$OuterBoxLabelManagementOrderState === 'editOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.$setOrderStatu('listShow');

          _this.$emit('cbOnHandleBlackBtn');
        }).catch(function () {
          _this.$message.warning('已取消');
        });
      } else if (this.$OuterBoxLabelManagementOrderState === 'orderShow') {
        this.$setOrderStatu('listShow');
        this.$emit('cbOnHandleBlackBtn');
      }
    },
    // 明细导出
    onHandleDetailExport: function onHandleDetailExport() {
      var params = {
        ORGANIZE_ID: util.cookies.get('ORG_ID'),
        MST_ID: this.ID,
        BARCODE_TYPE: 1,
        EXPORT_FILE_NAME: '外箱标签明细' // Page:1,
        // Limit:999

      };
      this.setUnreadExportMessionNum();
      this.$message.success('已添加到 导出列表 中');
      ExportBoxCodeData(params); // if (res.code === 0) {
      //   return
      // } else {
      //   this.$message.warning('数据导出失败----' + res.message)
      //   return
      // }
    },
    // 组合打印内箱标签
    PrintParBarcodeGroup: function PrintParBarcodeGroup() {
      console.log('this.submitObj', this.submitObj);

      if (!this.templateID) {
        this.$message({
          showClose: true,
          message: this.$t('找不到条码打印模板！'),
          type: 'warning'
        });
        return;
      }

      var token = util.cookies.get('token');
      var dataurl = process.env.VUE_APP_API + "/DnBarcode/GetBoxCodeDetailPrintData?mst_id=".concat(this.ID);
      var dxurl = this.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
      var url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(this.templateID, "&Token=").concat(token);
      util.open(url);
    },
    // 组合打印内箱标签
    onHandlePrintParBarcodeGroup: function onHandlePrintParBarcodeGroup() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  Page: _this2.pageInfo.PageIndex,
                  Limit: _this2.pageInfo.PageSize,
                  MST_ID: _this2.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context.next = 3;
                return GetBoxCodeDetailList(params);

              case 3:
                res = _context.sent;
                console.log('标签List', res);

                if (res.code === 0) {
                  if (res.data.length > 0) {
                    _this2.PrintParBarcodeGroup();
                  } else {
                    _this2.$message.warning('标签列表为空，请先生成标签');
                  }
                } else {
                  _this2.$message.warning('获取标签列表失败');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  Page: _this3.pageInfo.PageIndex,
                  Limit: _this3.pageInfo.PageSize,
                  MST_ID: _this3.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context2.next = 3;
                return GetBoxCodeDetailList(params);

              case 3:
                res = _context2.sent;
                console.log('标签List', res);

                if (res.code === 0) {
                  if (res.data.length > 0) {
                    _this3.$message.warning('已生成标签，不能修改');
                  } else {
                    _this3.$setOrderStatu('editOrder');
                  }
                } else {
                  _this3.$message.warning('获取标签列表失败');
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 生成标签
    handleCreatePartBarcode: function handleCreatePartBarcode() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res, res2;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  ID: _this4.ID,
                  CREATORID: _this4.userInfo.USER_NAME,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };

                _this4.$openLoading();

                _context3.next = 4;
                return CreatePartDetailDataOuterBox(params);

              case 4:
                res = _context3.sent;

                _this4.$closeLoading();

                console.log('生成物料 res', res);

                if (!(res.code === 0)) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 10;
                return CreateBoxCodeData(params);

              case 10:
                res2 = _context3.sent;
                console.log('生成标签 res', res2);

                _this4.GetPartBarcodeDetailList();

                _context3.next = 16;
                break;

              case 15:
                _this4.$message.warning(res.message);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 保存
    handleSaveOrder: function handleSaveOrder() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var GetDetailListParams, DetailListRes, submitData, params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.$refs.TabelHeader.valiData() === true)) {
                  _context4.next = 21;
                  break;
                }

                GetDetailListParams = {
                  MST_ID: _this5.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context4.next = 4;
                return GetDetailList(GetDetailListParams);

              case 4:
                DetailListRes = _context4.sent;

                if (!(DetailListRes.code === 0)) {
                  _context4.next = 11;
                  break;
                }

                if (!(DetailListRes.data[0].PACKING_QTY === 0)) {
                  _context4.next = 9;
                  break;
                }

                _this5.$message.warning('该送货单[外箱装箱数量]为0，不能生成外箱条码');

                return _context4.abrupt("return");

              case 9:
                _context4.next = 13;
                break;

              case 11:
                _this5.$message.warning('获取物料明细失败');

                return _context4.abrupt("return");

              case 13:
                submitData = _this5.$refs.TabelHeader.getData();
                params = {
                  // ID: 0,
                  CREATETIME: submitData.CREATETIME,
                  // CREATETIME: null,
                  CREATORID: _this5.userInfo.USER_NAME,
                  // DELETED: 0,
                  // BILL_TYPE: 1,
                  DELIVERY_NO: submitData.DELIVERY_NO,
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  // STATUS: 0,
                  VENDOR_CODE: submitData.VENDOR_CODE,
                  VENDOR_NAME: submitData.VENDOR_NAME,
                  DESCRIPTION: submitData.DESCRIPTION
                };

                if (_this5.$OuterBoxLabelManagementOrderState === 'editOrder') {
                  params.ID = _this5.ID;
                }

                _context4.next = 18;
                return SaveData(params);

              case 18:
                res = _context4.sent;
                console.log('保存 res', res);

                if (res.code === 0) {
                  _this5.ID = res.data;

                  _this5.$message.success('保存成功，请点击生成标签');

                  _this5.setOrderStatu('orderShow');
                }

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 选择送货单
    handleSelectOrder: function handleSelectOrder() {
      this.$refs.TabelHeader.ShowChangeOrderDialog();
    },
    // 下一张
    nextOrder: function nextOrder() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  mst_id: _this6.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };

                _this6.$openLoading();

                _context5.next = 4;
                return GetLastById(params);

              case 4:
                res = _context5.sent;

                _this6.$closeLoading();

                console.log('下一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this6.ID = res.data.ID;

                    _this6.$refs.TabelHeader.setData(res.data);

                    _this6.GetPartBarcodeDetailList();
                  } else {
                    _this6.$message.warning('当前单据已为最后单据');
                  }
                } else {
                  _this6.$message.warning('切换下一张单据失败');
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 上一张
    getBackOrder: function getBackOrder() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // this.$refs.TabelHeader.getBackUpdata()
                params = {
                  mst_id: _this7.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };

                _this7.$openLoading();

                _context6.next = 4;
                return GetNextById(params);

              case 4:
                res = _context6.sent;

                _this7.$closeLoading();

                console.log('上一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this7.ID = res.data.ID;

                    _this7.$refs.TabelHeader.setData(res.data);

                    _this7.GetPartBarcodeDetailList();
                  } else {
                    _this7.$message.warning('当前单据已为最前单据');
                  }
                } else {
                  _this7.$message.warning('切换上一张单据失败');
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取标签List
    GetPartBarcodeDetailList: function GetPartBarcodeDetailList() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  Page: _this8.pageInfo.PageIndex,
                  Limit: _this8.pageInfo.PageSize,
                  MST_ID: _this8.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _this8.loading = true;
                _context7.next = 4;
                return GetBoxCodeDetailList(params);

              case 4:
                res = _context7.sent;
                console.log('外箱标签List', res);

                if (res.code === 0) {
                  _this8.$refs.EditTable.setData(res.data);

                  _this8.loading = false;
                } else {
                  _this8.$message.warning('获取标签列表失败');

                  _this8.loading = false;
                }

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 获取单据详情
    asyncData: function asyncData() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = {
                  Page: 1,
                  Limit: 999,
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    VENDOR_CODE: util.getVENDOR_CODE(),
                    ID: _this9.ID
                  }
                };
                _context8.next = 3;
                return LoadData(params);

              case 3:
                res = _context8.sent;
                console.log('单据明细 res', res);

                if (res.code === 0 && res.data.Items.length > 0) {
                  _this9.$nextTick(function () {
                    // 设置ID
                    _this9.ID = res.data.Items[0].ID;

                    _this9.$refs.TabelHeader.setData(res.data.Items[0]);

                    _this9.GetPartBarcodeDetailList();
                  });
                } else {
                  _this9.$message.warning('获取单据详情失败');
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 设置送货单号
    setDELIVERY_NO: function setDELIVERY_NO(ID) {
      this.ID = ID;
      this.asyncData();
    },
    // 获取打印模板id
    GetReportID: function GetReportID() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                params = {
                  billtype: 'PartBarcode'
                };
                _context9.next = 3;
                return _GetReportID(params);

              case 3:
                res = _context9.sent;
                console.log('模板id', res);

                if (res.code === 0) {
                  _this10.templateID = res.data;
                } else {
                  _this10.$message.warning('获取打印模板失败');
                }

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    } // 分割线--------------------------------------------------------------------

  }),
  watch: {
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.TabelHeaderData = null;
          this.isShowTabelHeader = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.TabelHeaderData = null;
          this.isShowTabelHeader = true;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowTabelHeader = true;
        } else if (nawValue === 'editOrder') {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState']))
};